import React, { useEffect } from "react";
import { ArrowRight, Heart, ExternalLink } from "lucide-react";
import ExtendedWarrantyScreenWrapper, {
  ExtendedWarrantyHeader,
  ExtendedWarrantyCard,
  ExtendedWarrantyButton
} from "./ExtendedWarrantyScreenWrapper";
import analyticsService from "../../lib/AnalyticsService";

const ExtendedWarrantyExitScreen = ({ onExit }) => {
  useEffect(() => {
    analyticsService.trackEvent("Extended Warranty Page View", {
      page: "ew_exit",
      screen: "exit",
      flow_type: "extended-warranty",
    });
  }, []);

  const handleRedirectToOwnli = () => {
    analyticsService.trackEvent("Extended Warranty Flow Exit", {
      exit_point: "exit_screen",
      destination: "ownli_co",
      flow_type: "extended-warranty",
    });
    window.location.href = 'https://www.ownli.co';
  };

  const handleDownloadApp = () => {
    analyticsService.trackEvent("Extended Warranty Flow Exit", {
      exit_point: "exit_screen",
      destination: "ownli_co_individuals",
      flow_type: "extended-warranty",
    });
    window.open('https://www.ownli.co/individuals', '_blank');
  };

  return (
    <ExtendedWarrantyScreenWrapper>
      <ExtendedWarrantyHeader
        title="Thanks for Your Time!"
        subtitle="We appreciate you checking out extended warranty options with us."
        icon={<Heart className="w-8 h-8 text-purple-500" />}
      />

      <ExtendedWarrantyCard>
        <div className="text-center space-y-4">
          <p className="text-darkGrey">
            Even though extended warranty isn't the right fit for you right now, 
            Ownli has many other ways to help you earn rewards from your data.
          </p>
          
          <div className="bg-purple-50 p-4 rounded-lg">
            <h3 className="font-bold text-purple-900 mb-2">What else can you do with Ownli?</h3>
            <div className="text-sm text-purple-700 space-y-1">
              <p>• Earn rewards for connecting your vehicle data</p>
              <p>• Get paid for sharing your insurance information</p>
              <p>• Complete surveys and earn cash</p>
              <p>• Connect financial accounts for rewards</p>
            </div>
          </div>
        </div>
      </ExtendedWarrantyCard>

      <div className="space-y-3">
        <ExtendedWarrantyButton onClick={handleRedirectToOwnli}>
          Explore Other Ownli Offerings
          <ExternalLink className="w-4 h-4" />
        </ExtendedWarrantyButton>

        <button
          onClick={handleDownloadApp}
          className="w-full flex items-center justify-center gap-2 border border-purple-300 text-purple-700 px-4 py-3 rounded-lg hover:bg-purple-50 transition-colors"
        >
          Download Ownli App
          <ArrowRight className="w-4 h-4" />
        </button>
      </div>

      <div className="text-center">
        <p className="text-xs text-gray-500">
          Thank you for using Ownli. We're always here when you're ready to earn from your data.
        </p>
      </div>
    </ExtendedWarrantyScreenWrapper>
  );
};

export default ExtendedWarrantyExitScreen;
